<template>
  <div class="customPage terms">
    <h2 class="customPageTitle">이용약관</h2>
    <div class="customPageContent">
<pre>
[제 1장 총칙]
제1조(목적)
위던 이용약관(이하 “본 약관”)은 주식회사 스토리앤브라더스㈜(이하 “회사”)가 제공하는 위던 어플리케이션 서비스(이하 “서비스)의 이용과 관련하여 회사와 회원과의 권리, 의무 및 책임사항, 기타 필요한 사항을 규정함을 목적으로 합니다.

제2조(약관의 효력 및 변경)
①“회사”는 “본 약관”의 내용을 “회원”이 쉽게 알 수 있도록 서비스의 화면에 게시하거나 기타의 방법으로 공지하고, “본 약관”에 동의한 회원 모두에게 그 효력이 발생합니다.
②"회사"는 "약관의규제에관한법률", "정보통신망이용촉진및정보보호등에관한법률(이하 "정보통신망법")" 등 관련법을 위배하지 않는 범위에서 이 약관을 개정할 수 있습니다.
③"회사"가 약관을 개정할 경우에는 적용일자 및 개정사유를 명시하여 현행약관과 함께 제1항의 방식에 따라 그 개정약관의 적용일자 7일 전부터 적용일자 전일까지 공지합니다. 다만, “회원”에게 불리한 약관의 개정의 경우에는 공지 외에 일정기간 전자우편, 전자쪽지, 서비스내 공지 등의 전자적 수단을 통해 개별적으로 알려 드리겠습니다.
④”회사”가 전항에 따라 개정약관을 공지 또는 통지하면서 “회원”에게 14일 기간 내에 의사표시를 하지 않으면 의사표시가 표명된 것으로 본다는 뜻을 명확하게 공지 또는 통지하였음에도 “회원”이 명시적으로 거부의 의사표시를 하지 아니한 경우 회원이 개정약관에 동의한 것으로 봅니다.
⑤”회원”이 개정약관의 적용에 동의하지 않는 경우 “회원”은 이용계약을 해지할 수 있습니다. 다만, 기존 약관을 적용할 수 없는 특별한 사정이 있는 경우에는 “회사”는 이용계약을 해지할 수 있습니다.

제 3 조 (약관 외 준칙)
①“본 약관”에 규정되지 않은 사항에 대해서는 관련법령 또는 회사가 정한 서비스의 운영정책 및 규칙 등(이하 ‘세부지침’)의 규정에 따릅니다.

제 4 조 (용어의 정의)
①본 약관에서 사용하는 용어의 정의는 다음과 같습니다.
1. 위던 : 조력자가 동기부여를 제공하고 도전자가 목표달성 후 조력자에게 보상을 받는 서비스와 이외 부가적인 서비스를 제공하는 어플리케이션을 말합니다.
2. 회원 : 스토리앤브라더스㈜ "위던 서비스"에 개인정보를 제공하여 "회원"등록을 한 자로서, “본 약관”에 따라 “회사”와 이용계약을 체결하고 “서비스”를 이용하는 이용자를 말합니다.
3. 조력자 : 챌린지 등록, 도전자 초대를 수행하는 “회원”을 말합니다.
4. 도전자 : 조력자의 초대를 수락하여 목표 수행 활동을 하는 “회원”을 말합니다.
5. 챌린지 등록 : 도전자가 수행할 목표의 수행기간 및 조력자가 제공할 보상을 입력하는 활동을 말합니다.
6. 보상 : 도전자가 목표를 달성 했을 시 조력자가 제공할 선물을 말합니다.
7. 캘린더 : 도전자가 “회사”에서 제공하는 에디터를 활용해서 목표 수행 활동 과정을 올리는 콘텐츠를 말합니다.
8. 인증도장 : 조력자가 도전자의 목표 수행 활동 과정을 승인하는데 사용하는 “도장”을 말합니다.

[제 2장 서비스계정 이용계약]
제 5 조 (이용계약의 성립)
①서비스 이용신청은 “회원”이 되고자 하는 자(이하 “가입신청자”)가 “본 약관”의 내용에 동의한 후 이용신청을 하면 “회사”가 가입을 승낙함으로써 체결됩니다.
②이용계약의 성립시기는 ‘튜토리얼’을 신청절차 상에서 표시한 시점으로 합니다.


제 6 조 (회사의 이용계약의 거절 및 유보)
①제5조에 따른 “가입신청자”에게 “회사”는 원칙적으로 서비스의 이용을 승낙합니다. 다만, 회사는 아래 각 호의 경우에는 그 사유가 해소될 때까지 승낙을 유보하거나 승낙하지 않을 수 있습니다. 
1. 회사가 “본 약관” 또는 세부지침에 의해 “회원”의 계정을 삭제하였던 경우
2. ”회원”이 타인의 명의나 이메일 주소 등 개인정보를 이용하여 계정을 생성하려 한 경우
3. 제공 서비스 설비 용량에 현실적인 여유가 없는 경우
4. 서비스 제공을 위한 기술적인 부분에 문제가 있다고 판단되는 경우
5. 기타 회사가 재정적, 기술적으로 필요하다고 인정하는 경우
6. “회사”로부터 회원자격정지 조치 등을 받은 “회원”이 그 조치기간에 이용계약을 임의로 
해지하고 재이용을 신청하는 경우
7. 기타 관련법령에 위배되거나 세부지침 등 회사가 정한 기준에 반하는 경우
②만약, “회원”이 위 조건을 위반한 “가입신청자”라 판명된 때에는 “회사”는 즉시 “회원”의 서비스 이용을 정지시키는 등 적절한 제한을 할 수 있습니다. 나아가 그로 인한 불이익 및 법적책임은 “가입신청자”에게 있습니다.

제 7 조 (회사의 이용계약 해지 및 제한)
①“회사”는 다음의 경우 사전통보 없이 해당 “회원”과의 이용계약을 해지하여 영구적으로 “회원” 자격을 상실시킬 수 있습니다. 이 경우 재가입을 막을 수 있습니다.
1. 장기간 비로그인 상태일 경우
2. 타인의 개인정보 또는 모바일 기기를 사용한 경우
3. 다른 “회원”의 서비스 이용을 방해하는 등 전자거래질서를 위협하는 경우
4. 허위사실 유포, 위계기타 방법 등으로 “회사”의 명예 또는 신용을 훼손하거나 업무를 방해하는 경우
5. 기타 관련법령에 위배되거나 세부지침 등 회사가 정한 기준에 반하는 경우
②“회사”는 위의 사유가 있는 경우 계약해지 및 자격상실 대신 서비스 이용의 제한을 가할 수 있습니다.
③”회원”은 “서비스”의 이용권한, 기타 이용계약 상, 지위를 타인에게 양도 및 증여할 수 없으며, 이를 담보로 제공할 수 없습니다.

제 8 조 (회원의 해제 및 해지)
①"회원"은 "서비스" 이용계약을 해지(이하 "회원탈퇴")할 수 있습니다. "회원"이 "회원탈퇴"를 하기 위해서는 고객센터를 통해 "회원탈퇴" 신청을 할 수 있으며, 탈퇴 완료 시 "회원"의 이용 정보는 모두 삭제되어 복구 및 이용이 불가능합니다.
②"회원"이 "회원탈퇴"를 신청한 경우 "회사"는 "회원" 본인 여부를 확인할 수 있으며, 해당 "회원"이 본인으로 확인되는 경우 "회원"의 신청에 따른 조치를 취합니다.

[제 3장 서비스 이용]
제 9 조 (회원의 계정)
①“회원”이 “서비스”를 이용하려면 서비스 계정(이하 “계정”이라고 합니다)을 개설하여야 하며, “계정” 개설 시 정확하고 완전한 정보를 제공하고, 정보에 변동이 있는 경우 이를 업데이트 해야 합니다.
②“회사”는 부정한 방법으로 무분별하게 계정이 생성되는 것을 막기 위해 “회원”이 직접 입력하는 ID를 대신하여 SNS 가입연동과 본인 인증을 제공합니다. “계정”정보는 “서비스” 내 “회원” 본인을 제외한 타 회원에게 노출되지 않습니다.
③ “회원”은 “서비스” 내 마이페이지 화면을 통하여 본인의 개인정보를 열람하고 수정할 수 있습니다.
④“회원”이 자신의 “계정”을 도난당하거나 제3자가 사용하고 있음을 인지한 경우 즉시 “회사”에 통지하고 “회사”의 안내를 따라야합니다. “회사”에 통지하지 않거나, 안내에 따르지 않아 발생한 불이익에 대하여 “회사”는 책임지지 않습니다.
⑤“회사”는 “계정”의 무단도용으로 인하여 “회원”이 입은 손실에 대하여 책임을 지지 않습니다. 그러나 “회원”은 “계정”의 무단 도용으로 인해 “회사” 또는 타인이 입은 손해에 대해 책임을 질 수 있습니다. 단, “회원”에게 과실이 없는 때에는 그러하지 아니 합니다.
⑥”회사”는 더 나은 서비스계정 서비스의 제공을 위하여 “회원”에게 “서비스”의 이용과 관련된 각종 고지, 관리 메시지 및 기타 광고를 비롯한 다양한 정보를 서비스화면 내에 표시하거나 “회원”의 이메일로 전송할 수 있습니다.
제 10 조 (서비스의 내용 및 제공)
①“위던”은 “조력자”가 챌린지를 등록하여 “도전자”에게 목표 수행 활동을 수행하도록 요청하고 “도전자”에게 목표 달성 시 보상을 주는 서비스를 제공하는 플랫폼입니다.
②“조력자”는 챌린지등록 후 “인증도장”을 지급받을 수 있습니다.

제 11 조 (서비스의 제공 및 중단)
①(서비스 이용관련)서비스의 이용은 연중무휴, 1일 24시간을 원칙으로 합니다. 다만 회사의 업무상 또는 기술상의 이유로 서비스가 일시중지될 수 있습니다. 이러한 경우 “회사”는 사전 또는 사후에 이를 공지합니다. “회원”으로 가입한 이후라도 일부 “서비스”는 “회사”가 필요한 경우 특정 “회원”에게만 “서비스”를 제공할 수 있습니다. “회사”는 “서비스”를 일정 범위로 분할하여 각 범위 별로 이용 가능 시간을 별도로 정할 수 있습니다. 이 경우 그 내용을 사전 또는 사후에 이를 서비스화면 내에 공시하거나 “회원”에게 이를 통지합니다.
②(서비스 중단)회사의 업무상 또는 기술상의 장애로 인하여 서비스를 개시하지 못하는 경우에는 서비스화면 내에 공시하거나 “회원”에게 이를 통지합니다. “회사”에 보관되거나 전송된 메시지 및 기타 통신 메시지 등의 내용이 국가의 비상사태, 정전, “서비스” 관리범위 외의 서비스 설비 장애 및 기타 불가항력에 의하여 보관되지 못하였거나 삭제된 경우, 전송되지 못한 경우 및 기타 통신 데이터의 손실에 대해 “회사”는 관련 책임을 부담하지 않습니다. “회사”가 정상적인 서비스 제공의 어려움으로 인하여 일시적으로 서비스를 중지하여야 할 경우에는 서비스 중지 7일 전에 고지 후 “서비스”를 중지할 수 있으며, 이 기간동안 회원이 고지 내용을 인지하지 못한데 대하여 “회사”는 책임을 부담하지 아니합니다. 상당한 이유가 있을 경우 위 사전 고지기간은 감축되거나 생략될 수 있습니다. 또한 위 “서비스” 중지에 의하여 “서비스”에 보관되거나 전송된 메시지 및 기타 통신 메시지 등의 내용이 보관되지 못하였거나 삭제된 경우, 전송되지 못한 경우 및 기타 통신 데이터의 손실이 있을 경우 “회사”는 이에 대한 책임을 부담하지 않습니다. “회사”의 사정으로 서비스를 영구적으로 중단하여야 할 경우에 상기항을 준용합니다. 다만 이 경우에는 사전 고지 기간을 14일로 합니다. 천재지변, 국가비상사태 등 “회사” 관리 범위 외의 사유로 정상적인 서비스 제공이 불가능할 경우 일시적으로 서비스를 제한, 정지시킬 수 있으며 사전 또는 사후 “회원”에게 중지사유 및 기간을 공지합니다. “회사”는 사전 공지 후 “서비스”를 일시적으로 수정, 변경 및 중단할 수 있으며, 이에 대하여 “회원” 또는 제3자에 어떠한 책임도 부담하지 않습니다. “회사”는 긴급한 시스템 점검, 증설 및 교체 등 부득이한 사유로 인하여 예고없이 일시적으로 “서비스”를 중단할 수 있으며, 새로운 “서비스”로의 교체 등 “회사”가 적절하다고 판단하는 사유에 의하여 현재 제공되는 “서비스”를 완전히 중단할 수 있습니다. 회사가 통제할 수 없는 사유로 인한 서비스 중단의 경우(시스템 관리자의 고의, 과실 없는 디스크 장애, 시스템 다운 등)에 사전 통지가 불가능하며 타인(PC통신회사, 기간통신사업자 등)의 고의, 과실로 인한 시스템 중단 등의 경우에는 통지하지 않습니다. “회원”이 “본 약관”의 내용에 위배되는 행동을 한 경우, 임의로 서비스 사용을 제한 및 중지하거나 본인의 동의없이 이용 계약을 해지할 수 있습니다. 이 경우 “회사”는 “회원”의 접속을 금지할 수 있으며, 회원이 게시한 내용의 전부 또는 일부를 임의로 삭제할 수 있습니다. 1년 이상 휴면 회원인 경우에는 안내 메일 또는 공지사항 발표 후 1주일 간의 통지기간을 거쳐 서비스 사용을 중지할 수 있습니다.
③(서비스 이용 제한)회원이 제공하는 정보의 내용이 허위인 것으로 판명되거나, 허위가 있다고 의심할 만한 합리적인 사유가 발생할 경우 “회원”의 서비스 사용을 일부 또는 전부 이용 정지할 수 있으며, 이로 인해 발생하는 불이익에 대해 “회사”는 책임을 부담하지 아니합니다. “회원”이 본 약관의 내용에 위배되는 행동을 한 경우, 임의로 서비스 사용을 제한 및 중지할 수 있습니다. 이 경우 회사는 회원의 접속을 금지할 수 있습니다.

[제 4장 계약당사자의 권리와 의무]
제 12 조 (회원정보의 제공 및 변경)
①”회원"은 “본 약관”에 의하여 "회사"에 정보를 제공하여야 하는 경우에는 진실된 정보를 제공하여야 하며, 허위의 정보 제공으로 인하여 발생한 불이익에 대해서는 보호받지 못합니다.
②"회원"은 이용신청 시 기재한 사항이 변경되었을 경우, 즉시 해당 사항을 수정해야 합니다. 지체 없이 "서비스" 내 마이페이지나 "회사"의 고객센터 등을 통하여 변경된 정보로 수정하여야 합니다. 변경된 사항을 "회사"에 알리지 않아 발생한 불이익에 대해서 "회사"는 책임을 지지 않습니다.

제 13 조 (개인정보의 보호 및 관리)
①"회사"는 관계 법령이 정하는 바에 따라 "회원"의 개인정보를 보호하기 위해 노력합니다. "회원" 개인정보의 보호 및 사용에 대해서는 관계 법령 및 "회사"가 별도로 고지하는 개인정보취급방침이 적용됩니다.
②"회사"는 "회원"의 귀책사유로 인하여 노출된 "회원"의 계정정보를 포함한 모든 정보에 대해서 일체의 책임을 지지 않습니다.

제 14 조 (회원의 권리와 의무)
①(회원의 의무)“회원”은 서비스 이용을 위해 가입할 경우 서드파티를 통해 (카카오톡 및 애플, 애플은 iOS 기기에 한함) 현재의 사실과 일치하는 완전한 정보(이하 "가입정보")를 제공해야 합니다. 또한 “가입정보”에 변경이 발생할 경우 즉시 갱신해야 합니다. “회원”이 서비스 사용을 위한 가입절차를 완료하면 암호화된 회원 식별 정보를 기기에 저장하게 됩니다. “회원”의 계정은 다음과 같이 관리를 해야 합니다.
1. “회원”의 승인없이 계정이 사용되는 문제가 발생되면 즉시 “회사”에 신고해야 합니다.
2. 매 접속 종료 시 확실히 로그아웃을 해야 합니다.
②”회원”은 “서비스”를 이용하면서 다음과 같은 행위를 하지 않기로 동의합니다.
1. 타인(소수를 포함)에게 위해를 가하는 행위
2. 타인의 ID, 비밀번호, 명의 도용 및 타인으로 가장하는 행위
3. 타인과의 관계를 허위로 명시하는 행위
4. 타인을 비방할 목적으로 사실 또는 허위의 사실을 적시하여 명예를 훼손하는 행위
5. 자기 또는 타인에게 재산상의 이익을 주거나 타인에게 손해를 가할 목적으로 허위의 정보를 유통시키는 행위
6. 수치심이나 혐오감 또는 공포심을 일으키는 말이나 음향, 글이나 화상 또는 영상을 계속하여 상대방에게 도달하게 하여 상대방의 일상적 생활을 방해하는 행위
7. “회사”의 사전 승낙 없이 서비스를 이용한 영리행위 또는 불필요하거나 승인되지 않은 광고, 판촉물을 게재하는 행위
8. 타인의 정보통신서비스 이용명의를 도용하여 사용하는 행위
9. 저속 또는 음란한 데이터, 텍스트, 소프트웨어, 음악, 사진, 그래픽, 비디오 메시지 등(이하 "콘텐츠")을 게시, 게재 또는 전자우편으로 보내는 행위
10. 권리(지적재산권을 포함한 모든 권리)가 없는 콘텐츠를 게시, 게재 또는 전자우편으로 보내는 행위
11. 컴퓨터 소프트웨어, 하드웨어, 전기통신 장비를 파괴, 방해 또는 기능을 제한하기 위한 소프트웨어 바이러스를 게시, 게재 또는 전자우편으로 보내는 행위
12. 다른 컴퓨터 코드, 파일, 프로그램을 포함하고 있는 자료를 게시, 게재, 전자우편으로 보내는 행위 등 다른 사용자의 개인정보를 수집 또는 저장하는 행위
13. 재물을 걸고 도박하거나 사행행위를 하는 행위
14. 윤락행위를 알선하거나 음행을 매개하는 내용의 정보를 유통시키는 행위
15. 기타 불법적이거나 부당한 행위
③회원은 본 약관 및 관계법령에서 규정한 사항을 준수하여야 합니다.

제 15 조 (회사의 권리와 의무)
①(회사의 권리)회사는 보안 및 ID 정책, 서비스의 원활한 제공 등과 같은 이유로 회원의 닉네임변경을 요구하거나 변경할 수 있습니다.
②(회사의 소유권)”회사”가 제공하는 “서비스”, 그에 필요한 소프트웨어, 이미지, 마크, 로고, 디자인, 서비스 명칭, 정보 및 상표 등과 관련된 지적재산권 및 기타 권리는 “회사”에게 있습니다. “회원”은 회사가 명시적으로 승인한 경우를 제외하고는 상기항에 기재한 소정의 각 재산에 대한 전부 또는 일부의 수정, 대여, 대출, 판매, 배포, 제작, 양도, 재라이센스, 담보권설정행위, 상업적 이용행위를 할 수 없으며, 제3자로 하여금 이와 같은 행위를 하도록 허락할 수 없습니다.
③(회사의 의무)”회사”는 법령과 본 약관이 금지하거나 미풍양속에 반하는 행위를 하지 않으며, 지속적 안정적으로 서비스를 제공하기 위하여 노력할 의무가 있습니다. “회사”는 “회원”의 개인 신상 정보를 본인의 승낙 없이 제3자에게 누설, 배포하지 않습니다. 다만, 관계법령에 의해 국가기관의 요구나 전기통신관련법령 및 정보통신윤리위원회의 요청 등 법률의 규정에 따른 적법한 절차에 의한 경우에는 그러하지 아니합니다. “회사”는 계속적이고 안정적인 서비스의 제공을 위하여 설비에 장애가 생기거나 멸실 된 때에는 부득이한 사유가 없는 한 지체없이 이를 수리 또는 복구합니다. “회사”가 제공하는 “서비스”로 인하여 “회원”에게 손해가 발생한 경우 그러한 손해가 “회사”의 고의나 중과실에 의해 발생한 경우에 한하여 책임을 부담하며, 그 책임의 범위는 통상손해에 한합니다. “회사”는 “회원”으로부터 제기되는 의견이나 불만이 정당하다고 인정할 경우에는 신속히 처리하여야 합니다. 다만, 신속한 처리가 곤란한 경우에는 “회원”에게 그 사유와 처리일정을 통보하여야 합니다. “회사”는 관련법령이 정하는 바에 따라서 회원 등록정보를 포함한 “회원”의 개인정보를 보호하기 위하여 노력합니다. “회원”의 개인정보보호에 관해서는 관련법령 및 이용약관 중 개인정보 취급방침에 제시된 내용을 지킵니다.

제 15 조 (면책 및 책임)
①(면책조항)”회사”는 천재지변, 전쟁 및 기타 이에 준하는 불가항력으로 인하여 서비스를 제공할 수 없는 경우에는 서비스 제공에 대한 책임이 면제됩니다. “회사”는 기간통신 사업자가 전기통신 서비스를 중지하거나 정상적으로 제공하지 아니하여 손해가 발생한 경우 책임이 면제됩니다. “회사”는 서비스용 설비의 보수, 교체, 정기점검, 공사 등 부득이한 사유로 발생한 손해에 대한 책임이 면제됩니다. “회사”는 이용자의 컴퓨터 오류에 의해 손해가 발생한 경우, 또는 “회원”이 신상정보 및 전자우편 주소를 부실하게 기재하여 손해가 발생한 경우 책임을 지지 않습니다. “회사”는 “회원”이나 제3자에 의해 표출된 어떠한 의견이나 정보에 대해 확신이나 대표할 의무가 없으며 의견을 승인하거나 반대하거나 수정하지 않습니다. “회사”는 어떠한 경우라도 “회원”이 “서비스”에 담긴 정보에 의존해 얻은 이득이나 입은 손해에 대해 책임이 없습니다. “회사”는 “회원”간 또는 “회원”과 제3자간에 서비스를 매개로 하여 물품거래 혹은 금전적 거래 등과 관련하여 어떠한 책임도 부담하지 아니하고, “회원”이 “서비스”의 이용과 관련하여 기대하는 이익에 관하여 책임을 부담하지 않습니다. “회사”는 이용자 또는 기타 유관기관이 서비스에 게재한 정보에 대해 정확성, 신뢰도에 대하여 보장하지 않습니다. 따라서 “회사”는 이용자가 위 내용을 이용함으로 인해 입게 된 모든 종류의 손실이나 손해에 대하여 책임을 부담하지 아니합니다. “회사”는 이용자가 “서비스” 이용과 관련하여 가입자에게 발생한 손해 중 가입자의 고의, 과실에 의한 손해 및 타 이용자로 인해 입게 되는 정신적 피해에 대하여 보상할 책임을 지지 않습니다.
②(손해배상)”회사”는 무료로 제공되는 서비스와 관련하여 회원에게 어떠한 손해가 발생하더라도 “회사”가 고의로 행한 범죄행위를 제외하고 이에 대하여 책임을 부담하지 아니합니다.

[제 5장 서비스 이용 관련 정책]
제 16 조 (콘텐츠의 관리 및 운영)
①”회원”이 게시한 모든 콘텐츠의 저작권은 “회사”가 소유하며, “회사”는 다음 각 호에 해당하는 콘텐츠를 금지합니다. 이를 위반한 경우, “회사”는 해당 콘텐츠에 대해 사전통지 없이 삭제, 이동 또는 등록거부의 조치를 취할 수 있습니다.
1. 타인(회사 및 콘텐츠의 출연자 포함)의 명예를 훼손하거나 근거 없이 비방하는 내용
2. 욕설, 음란/외설적 내용, 폭력적인 내용 등 미풍양속에 반하는 내용
3. 저작권을 포함한 타인(회사 및 콘텐츠의 출연자 포함)의 지식재산권을 침해하는 내용
4. 선량한 풍속 기타 사회질서에 반하는 내용
5. 민감한 개인정보를 포함한 내용
6. "회사"는 “회원”의 "콘텐츠"에 대해서는 적법성, 정확성, 진실성 등을 보증하지 않습니다.
7. 위반 사유가 확인되었거나 일정 횟수 이상 신고를 받은 콘텐츠에 대해서 ”회사”는 임시삭제 조치를 취할 수 있으며 해당 콘텐츠를 작성한 “회원”은 “서비스”의 이용을 제한, “계정” 중지, 이용계약 해지를 할 수 있습니다. 단, 해당 콘텐츠를 작성한 “회원”은 자신의 콘텐츠가 제2항의 위반 사유에 해당하지 않음을 소명하여 해당 조치를 해제할 수 있습니다.
②”회사”는 콘텐츠가 일정기간 이상 경과되어, 콘텐츠로써의 효력을 상실하여 그 존치 목적이 불분명한 경우 해당 콘텐츠를 이동 또는 삭제할 수 있습니다. “회원”의 콘텐츠가 타인의 저작권을 침해함으로써 발생하는 민, 형사상의 책임은 전적으로 “회원”이 부담하여야 합니다. 또한 “회원”이 “서비스”를 이용하여 얻은 정보를 가공, 판매하는 행위 등 “서비스”에 게재된 콘텐츠를 상업적으로 사용할 수 없습니다. 위와 같이 “회원”이 본 서비스를 통해 얻은 정보(업무 내용, 영업 정보, 개인정보 등)를 부당하게 이용하는 경우 “회사”는 법적인 대응을 할 수 있습니다.

제 17 조 (지적재산권)
①(제3자의 지적재산권보호)”회원”은 제3자의 저작권 등을 침해하여서는 안됩니다. 만일 업무에 따른 저작물의 내용이 제3자의 저작권 등의 권리를 침해하여 “회원” 또는 제3자에게 손해를 끼칠 경우에 “회원”은 ’민, 형사상의 모든 책임을 지게 됩니다. “회사”는 도용이나 침해가 의심되는 저작물에 대해 조사하지 않습니다. “회원”이 직접 도용이나 침해 여부를 판가름한 뒤 “회사”에 알려주어야 합니다.
②(게재할 권리의 보호)”회원”은 완료된 업무 결과물에 대해서 “회사”가 홍보를 위한 수단으로 온라인 및 오프라인 상에서 업무의 결과를 별도의 로열티 없이 자유롭게 지속적으로 사용하는 것을 동의합니다. 다만 “회원”이 업무의 목적 상 게재를 허용치 않는 경우 게재 이전에 의사를 통보할 의무가 있으며, 이 통보에 따라 “회사”는 게재할 권리를 상실하게 됩니다.

제 18 조 (광고의 게재)
①"회사"는 "서비스"의 운영과 관련하여 "서비스" 화면, 홈페이지, LMS/SMS, 알림 메시지(Push Notification), 이메일 등을 통하여 광고를 제공할 수 있습니다.
②“회사”는 “서비스” 내 배너, PPL 등을 통하여 광고를 게재할 수 있습니다.
③해당 광고는 제3자가 제공하는 영역, 페이지와 연결될 수 있으며, 제3자가 제공하는 페이지로 연결될 경우 해당 페이지는 "회사"의 "서비스" 영역이 아니므로 "회사"는 해당 페이지의 신뢰성, 안정성 등을 보장하지 않으며 그로 인한 "회원"의 손해에 대하여 책임을 지지 않습니다.
제 19 조 (마케팅 알림 동의)
①위던 어플리케이션의 푸시 알림을 통해 위던과 제휴사의 상품, 서비스, 이벤트, 맞춤 혜택 및 서비스 정보 등의 안내 등 마케팅 정보를 수신하는 것에 동의합니다.
②본 동의는 귀하께서 위던 어플리케이션을 설치, 이용하시는 동안 유효합니다. 귀하는 동의를 거부할 권리가 있으나, 상기 동의사항은 상거래관계의 설정, 유지에 필수적이거나, 상거래 관계에 따라 귀하에게 제공되는 서비스와 직접적으로 관련되어 있는 것으로서 위 사항에 동의하지 않으실 경우 거래관계의 설정 또는 유지가 불가능할 수 있습니다.
③동의하지 않으신 경우에도, 마케팅 정보 외에 귀하께 알려드릴 필요가 있는 중요한 내용들은 전송될 수 있습니다.

제 20 조 (준거법 및 합의 관할)
①서비스 이용과 관련하여 회사와 회원 사이에 분쟁이 발생한 경우, 회사와 회원은 발생한 분쟁을 원만하게 해결하기 위하여 필요한 모든 노력을 하여야 합니다. 발생한 분쟁에 대하여 소송이 제기될 경우에는 회사의 소재지를 관할하는 법원을 관할 법원으로 합니다.
②"회사"와 "회원" 간에 제기된 법적 분쟁은 대한민국 법을 준거법으로 합니다.
③(부칙)본 약관은 2021년 4월 1일에 작성되었으며, 2021년 4월 8일부터 적용됩니다.

</pre>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Terms'
}
</script>

<style lang="scss" scoped>
.terms{
  pre{
    max-width: 100%;
    width: 100%;
    margin-bottom: 16px;
    word-break: break-all;
    white-space: pre-wrap;
    font-size: 14px;
    font-family: 'Pangolin', 'Noto Sans KR';
  }
  table{
    margin-bottom: 32px;
    table-layout: fixed;
    border-collapse: collapse;

    th, td{
      width: 33.3333%;
      padding: 8px;
      border-left: 1px solid #ccc;
      border-right: 1px solid #ccc;
      border-bottom: 1px solid #ccc;
      font-size: 14px;
    }
    th{
      border-top: 1px solid #ccc;
      margin-bottom: 16px;
      background-color: #f4f4f4;
    }
  }
}
</style>